module.exports = __webpack_public_path__ + "img/qrpreview.884b6411.png";